// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wel-ui/components/Heading/index.css
// module id = 157
// module chunks = 0